import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  News,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { Grid } from "@mui/material";
import { FeatureCard } from "../components/Hero";
import { FeatureCardSmall } from "../components/Hero";
import CellTowerIcon from "@mui/icons-material/CellTower";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import WorkIcon from "@mui/icons-material/Work";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import BuildIcon from "@mui/icons-material/Build";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PersonIcon from "@mui/icons-material/Person";
import Lottie from "react-lottie";
import { TypeAnimation } from "react-type-animation";
import bg from "../img/bg.mp4";

export default function About() {
  useEffect(() => {
    axios
      .get(API_URL + "get_people")
      .then((res) => {
        setPeople(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error("Error fetching people:", err);
        setPeople([]);
      });
    axios
      .get(API_URL + "get_gallery")
      .then((res) => {
        setGallery(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error("Error fetching gallery:", err);
        setGallery([]);
      });
  }, []);
  const [people, setPeople] = useState([]);
  const [gallery, setGallery] = useState([]);

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <video
          src={bg}
          type="video/mp4"
          autoPlay
          loop
          muted
          id="video"
          className="video"
        />

        <div style={{ backgroundColor: "white" }}>
          <div
            style={{
              height: "80vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: "70px",
                  fontSize: state.auth.isMobile ? "50px" : "65px",
                  color: "white",
                  fontWeight: 600,
                  zIndex: 999,
                  textAlign: state.auth.isMobile ? "left" : "center",
                }}
              >
                About Us
              </div>

              <div
                style={{
                  borderBottom: "2px solid white",
                  width: "100%",
                  margin: "5px 0px 5px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "45px",
                  color: "white",
                  zIndex: 999,
                  textAlign: state.auth.isMobile ? "left" : "center",
                }}
              >
                Driving value through innovative IT Solutions.
              </div>
            </div>
          </div>
        </div>
        <ContentSideBySideInv
          title="About our Company"
          subtitle="At CGT Solutions, we stand at the pinnacle of IT excellence, offering innovative technology solutions that drive business transformation. As a trusted leader in the IT industry, we excel in delivering comprehensive services, including advanced Software Development, Cloud Solutions, Cybersecurity, IT infrastructure support, and IT staffing solutions on a permanent or project basis.
                    Our mission is to empower businesses with scalable and secure technology solutions tailored to their unique needs, enabling them to thrive in an increasingly digital world. Through our expertise and unwavering commitment to innovation, we help organizations stay ahead of the technological curve and achieve sustainable growth."
          image={
            <img
              style={{ width: "100%", marginTop: "15px" }}
              src={require("../img/about1.jpg")}
            />
          }
        />
        {state.auth.isMobile ? <div style={{ marginTop: "200px" }} /> : ""}
        <ContentSideBySide
          title="Our Evolution"
          subtitle="CGT Solutions has evolved from a dynamic assembly of strategists, creative directors, designers, technologists, developers, and relationship builders into a formidable force in the IT solutions and staffing industry. With an unwavering commitment to creating vibrant, impactful experiences, we leverage our extensive product and technology expertise to meet our clients' needs at every level.
                    As champions of digital transformation, we craft human-centric experiences that lie at the intersection of strategy, design, and technology. Our forward-thinking approach has led us to invest heavily in innovation hubs and labs, enabling us to stay at the forefront of cutting-edge technologies such as Cybersecurity, Cloud Computing, the Internet of Things (IoT), and Artificial Intelligence (AI), Kubernetes.
                    Our journey is characterized by continuous growth and a steadfast dedication to excellence, positioning CGT Solutions as a trusted partner in navigating the complexities of today’s digital landscape.​​"
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/rocket2.json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />

        <div
          className="anigrad"
          style={{
            textAlign: "center",
            padding: state.auth.isMobile ? "20px" : "100px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Grid
            style={{
              display: "flex",
              justifyContent: "center",
            }}
            container
            spacing={5}
          >
            <Grid
              item
              md={3}
              xs={10}
              sm={10}
              style={{
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "start",
                flexDirection: "column",
                alignItems: "start",
                fontSize: "50px",
                color: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              What is <span>imprinted</span> in our
              DNA.
            </Grid>
            <Grid
              item
              md={8}
              xs={10}
              sm={10}
              style={{
                width: "100%",
                textAlign: "left",
                display: "flex",
                justifyContent: "start",
                flexDirection: "column",
                alignItems: "start",
                fontSize: "50px",
                color: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "40px",
                  color: "#ddd",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Vision
              </div>
              <div
                style={{
                  fontSize: "20px",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                To be a global leader in technology innovation, shaping the future of IT with smarter,
                more connected, and sustainable solutions for an increasingly digital world.
              </div>
              <div
                style={{
                  margin: "25px 0px 25px 0px",
                  borderBottom: "1px solid #ddd",
                }}
              ></div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "30px" : "40px",
                  color: "#ddd",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Mission
              </div>
              <div
                style={{
                  fontSize: "20px",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                To empower businesses through the delivery of innovative, secure, and scalable IT solutions. We aim to drive digital transformation and enhance operational
                excellence, all while providing exceptional value to our clients and stakeholders.
              </div>
            </Grid>
          </Grid>
        </div>
        <ContentSideBySideInv
          title="Our Core Values"
          subtitle={
            <ul style={{ marginLeft: "-40px" }}>
              {" "}
              <div style={{ fontSize: "20px" }}>Empower and uplift others</div>
              <br />
              <div style={{ fontSize: "20px" }}>
                Embrace diversity and inclusion
              </div>
              <br />
              <div style={{ fontSize: "20px" }}>
                Act with integrity and transparency
              </div>
              <br />
              <div style={{ fontSize: "20px" }}>
                Foster creativity and bold thinking
              </div>
              <br />
              <div style={{ fontSize: "20px" }}>
                Champion sustainability and responsibility
              </div>
              <br />
              <div style={{ fontSize: "20px" }}>
                Pursue excellence with purpose
              </div>
              <br />
              <div style={{ fontSize: "20px" }}>
                Cultivate trust and respect{" "}
              </div>
            </ul>
          }
          image={
            <img
              style={{ width: "100%", marginTop: "15px" }}
              src={require("../img/about2.jpg")}
            />
          }
        />
        <div style={{ height: "75px" }} />

        {/* <div
          style={{
            fontSize: state.auth.isMobile ? "30px":"40px",
            color: themeStyle.primaryColor,
            zIndex: 999,
            fontWeight: 600,
          }}
        >
          Our Team
        </div>
        <Gallery
          gallery={people.map((peep, index) => ({
            subtitle: peep["name"],
            title: peep["designation"],
            image: API_URL + peep["image"],
            content: peep["content"],
          }))}
        /> */}

        <div style={{ height: "50px" }} />
        <div
          style={{
            fontSize: state.auth.isMobile ? "30px" : "40px",
            color: themeStyle.primaryColor,
            zIndex: 999,
            backgroundColor: "white",
            fontWeight: 600,
          }}
        >
          Transform your business with advanced technologies
        </div>
        <News
          gallery={gallery.map((gall, index) => ({
            subtitle: gall["subtitle"],
            title: gall["title"],
            image: API_URL + gall["image"],
            page: gall["page"],
          }))}
        />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
